export default __webpack_public_path__ + "static/media/doselect-mark.a579d99f.svg";